import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../../ReactQuery';
import { get } from '../../../../redux/api';
import type { StripeInvoice } from '../../../../../typings/stripe';

function fetchInvoices() {
  return get<StripeInvoice[]>(`/api/organization/invoices`);
}

const getQueryKey = (): QueryKey => ['invoice-history'];

/**
 * Fetches the invoices
 */
export default function useInvoiceHistory() {
  return useQuery<StripeInvoice[]>({
    queryKey: getQueryKey(),
    queryFn: () => fetchInvoices(),
  });
}
